/**
 * Образцы цвета оверлеев для панели: чем будет раскрашена карта, если тумблер
 * включить.
 *
 * Правило то же, что у легенды тайлов (см. `/cabinet/legend`): образец НЕ
 * набирается на глаз, а выводится из тех же констант, которыми красит карта
 * (`isotherms.ts`, `frontsStyle.ts`, `arrows.ts`). Иначе цвет в панели и цвет на
 * карте разъезжаются при первой же правке стиля — а панель именно тем и полезна,
 * что по ней узнают линию среди трёх одновременно включённых.
 *
 * Линию показываем С ОРЕОЛОМ: на карте она рисуется двумя слоями (белая подложка
 * под тёмной линией), и графитовая изотерма без подложки на тёмной панели просто
 * не видна — образец врал бы о заметности.
 */
export type LineSwatch = { kind: 'line'; line: string; casing: string }
export type RampSwatch = { kind: 'ramp'; stops: string[] }
/** Тип каждого образца сужен намеренно: легенда карты берёт из линейных
 *  образцов сам цвет и ореол, и с общим объединением это не проходит типизацию. */
export type OverlaySwatch = LineSwatch | RampSwatch

import { ISOTHERM_CASING_COLOR, isothermLineColor, isothermSurfaceColor } from '../map/isotherms'
import { FRONT_CASING_COLOR, frontLineColor } from '../map/frontsStyle'
import { waveArrowColor } from '../models/arrows'

// Образцы собираются ФУНКЦИЯМИ, а не константами: гамма домена приезжает
// ответом `/cabinet/site`, то есть позже загрузки модуля, и константа застыла
// бы на нашем цвете — легенда показывала бы одно, а карта рисовала другое.
export function isothermSwatch(): LineSwatch {
  return { kind: 'line', line: isothermLineColor(), casing: ISOTHERM_CASING_COLOR }
}

/** Поверхностная изотерма — та же линия с ореолом, но своего цвета: на карте
 *  она лежит рядом с глубинной, и различает их только цвет. */
export function isothermSurfaceSwatch(): LineSwatch {
  return { kind: 'line', line: isothermSurfaceColor(), casing: ISOTHERM_CASING_COLOR }
}

export function frontSwatch(): LineSwatch {
  return { kind: 'line', line: frontLineColor(), casing: FRONT_CASING_COLOR }
}

/** Волнение красит стрелки течений рампой «штиль → шторм» — её и показываем. */
export const WAVE_SWATCH: RampSwatch = {
  kind: 'ramp',
  stops: [waveArrowColor(0), waveArrowColor(0.5), waveArrowColor(1)],
}

/** Доля высоты образца, которую занимает сама линия (остальное — ореол). */
const LINE_BAND = [0.3, 0.7]

export function swatchBackground(s: OverlaySwatch): string {
  if (s.kind === 'ramp') {
    // Один цвет — тоже градиент: `linear-gradient` с одной остановкой невалиден.
    const stops = s.stops.length > 1 ? s.stops : [s.stops[0], s.stops[0]]
    return `linear-gradient(to right,${stops.join(',')})`
  }
  const [from, to] = LINE_BAND.map(v => `${Math.round(v * 100)}%`)
  return (
    `linear-gradient(to bottom,${s.casing} 0 ${from},` +
    `${s.line} ${from} ${to},${s.casing} ${to} 100%)`
  )
}
